import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { CardPositionContext, ContentInfoContext } from '../../../contexts/TelemetryContexts';
import { ActionsMenu } from '../../ActionsMenu/ActionsMenu';
import { ExplorerStyles } from '../../Explorer/ExplorerStyles';

export interface ActionCellOptions {
  getContentItem: (row: DataGrid.Row) => IContentInfo;
  isRowSelected: (row: DataGrid.Row) => boolean;
  isAccessDenied: (row: DataGrid.Row) => boolean;
  isRowDisabled: (row: DataGrid.Row) => boolean;
}

export function ActionsMenuCell(
    options: ActionCellOptions,
    cellOverrides: React.CSSProperties = {}
): React.Factory<BodyCell.Props> {
  return React.createFactory(class extends React.Component<BodyCell.Props, {}> {

    render() {
      if (options.isAccessDenied(this.props.row)) {
        return null;
      }

      const disableRow = options.isRowDisabled(this.props.row);
      return (
          <div className={ExplorerStyles.ActionsOnlyCellContainer} style={disableRow ? ExplorerStyles.disabledCellStyle : cellOverrides}>
            <div>
              <ContentInfoContext.Provider value={options.getContentItem(this.props.row)}>
                <CardPositionContext.Provider value={this.props.row.data.rowIndex + 1}>
                  <ActionsMenu
                      targetItems={[options.getContentItem(this.props.row)]}
                      disabled={options.isRowSelected(this.props.row)}
                      tabIndex={-1} // disable tabbing in datagrid cells, leaving focus managed by datagrid itself
                      useIcon={true}/>
                </CardPositionContext.Provider>
              </ContentInfoContext.Provider>
            </div>
          </div>
      );
    }
  });
}
